import { motion } from 'framer-motion'

// Fixed star positions — no Math.random() on render
const STARS = [
  { left: '4%',  top: '6%',  s: 2,   d: 3.2, delay: 0    },
  { left: '12%', top: '18%', s: 1.5, d: 2.8, delay: 0.6  },
  { left: '22%', top: '9%',  s: 2.5, d: 3.8, delay: 1.1  },
  { left: '34%', top: '22%', s: 1,   d: 2.4, delay: 0.3  },
  { left: '48%', top: '5%',  s: 2,   d: 3.5, delay: 1.8  },
  { left: '61%', top: '14%', s: 1.5, d: 2.6, delay: 0.9  },
  { left: '73%', top: '8%',  s: 2,   d: 4.0, delay: 0.4  },
  { left: '83%', top: '20%', s: 1,   d: 2.2, delay: 1.3  },
  { left: '91%', top: '11%', s: 2.5, d: 3.1, delay: 0.7  },
  { left: '7%',  top: '35%', s: 1.5, d: 2.9, delay: 1.5  },
  { left: '27%', top: '40%', s: 1,   d: 3.4, delay: 0.2  },
  { left: '55%', top: '32%', s: 2,   d: 2.7, delay: 1.0  },
  { left: '78%', top: '38%', s: 1.5, d: 3.6, delay: 1.7  },
  { left: '94%', top: '30%', s: 1,   d: 2.3, delay: 0.5  },
  { left: '41%', top: '44%', s: 2,   d: 3.0, delay: 1.2  },
]

// SVG car component — all animation via native SVG animateTransform
function CarSVG() {
  return (
    <svg
      viewBox="0 0 300 120"
      className="w-[280px] sm:w-[340px] drop-shadow-2xl"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="cl-body" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0054b3" />
          <stop offset="100%" stopColor="#003e88" />
        </linearGradient>
        <linearGradient id="cl-roof" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0d6ee8" />
          <stop offset="100%" stopColor="#0054b3" />
        </linearGradient>
        <linearGradient id="cl-beam" x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#fef9c3" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#fef9c3" stopOpacity="0" />
        </linearGradient>
        <filter id="cl-glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="cl-tailglow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Headlight beam */}
      <polygon points="222,68 300,42 300,82" fill="url(#cl-beam)">
        <animate attributeName="opacity" values="0.7;1;0.7" dur="2.4s" repeatCount="indefinite" />
      </polygon>

      {/* Ground shadow */}
      <ellipse cx="140" cy="112" rx="108" ry="7" fill="rgba(0,0,0,0.28)" />

      {/* ── Car body (lower) ── */}
      <rect x="18" y="60" width="240" height="40" rx="10" fill="url(#cl-body)" />

      {/* Accent stripe */}
      <rect x="18" y="82" width="240" height="4" rx="0" fill="rgba(255,255,255,0.08)" />

      {/* ── Cabin / roof ── */}
      <path d="M58 60 L82 24 L188 24 L212 60 Z" fill="url(#cl-roof)" />

      {/* Rear window */}
      <path d="M86 27 L128 27 L128 57 L91 57 Z" fill="rgba(186,230,253,0.28)" stroke="rgba(186,230,253,0.15)" strokeWidth="1" />

      {/* B-pillar */}
      <rect x="128" y="26" width="5" height="34" rx="1" fill="#002d63" />

      {/* Front windshield */}
      <path d="M135 27 L175 27 L206 57 L135 57 Z" fill="rgba(186,230,253,0.28)" stroke="rgba(186,230,253,0.15)" strokeWidth="1" />

      {/* Window shine */}
      <line x1="140" y1="31" x2="200" y2="31" stroke="rgba(255,255,255,0.14)" strokeWidth="4" strokeLinecap="round" />

      {/* Door handle — rear */}
      <rect x="95" y="76" width="18" height="4" rx="2" fill="rgba(255,255,255,0.22)" />
      {/* Door handle — front */}
      <rect x="168" y="76" width="18" height="4" rx="2" fill="rgba(255,255,255,0.22)" />

      {/* Door gap */}
      <line x1="133" y1="62" x2="133" y2="96" stroke="rgba(0,0,0,0.3)" strokeWidth="2" />

      {/* Headlight */}
      <rect x="250" y="65" width="12" height="10" rx="3.5" fill="#fef9c3" filter="url(#cl-glow)" />
      <rect x="250" y="65" width="12" height="10" rx="3.5" fill="#fde68a" opacity="0.4" />

      {/* Taillight */}
      <rect x="12" y="65" width="9" height="10" rx="3" fill="#ef4444" filter="url(#cl-tailglow)" />
      <rect x="12" y="65" width="9" height="10" rx="3" fill="#fca5a5" opacity="0.35" />

      {/* ── Front wheel ── */}
      <circle cx="194" cy="100" r="17" fill="#0f172a" />
      <circle cx="194" cy="100" r="10" fill="#1e293b" />
      {/* Rotating spokes */}
      <g>
        <animateTransform attributeName="transform" attributeType="XML"
          type="rotate" from="0 194 100" to="360 194 100"
          dur="0.85s" repeatCount="indefinite" />
        <line x1="194" y1="83" x2="194" y2="117" stroke="#475569" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="177" y1="100" x2="211" y2="100" stroke="#475569" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="181.9" y1="87.9" x2="206.1" y2="112.1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="206.1" y1="87.9" x2="181.9" y2="112.1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" />
      </g>
      <circle cx="194" cy="100" r="4" fill="#475569" />
      <circle cx="194" cy="100" r="1.8" fill="#94a3b8" />

      {/* ── Rear wheel ── */}
      <circle cx="76" cy="100" r="17" fill="#0f172a" />
      <circle cx="76" cy="100" r="10" fill="#1e293b" />
      {/* Rotating spokes */}
      <g>
        <animateTransform attributeName="transform" attributeType="XML"
          type="rotate" from="0 76 100" to="360 76 100"
          dur="0.85s" repeatCount="indefinite" />
        <line x1="76" y1="83" x2="76" y2="117" stroke="#475569" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="59" y1="100" x2="93" y2="100" stroke="#475569" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="63.9" y1="87.9" x2="88.1" y2="112.1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="88.1" y1="87.9" x2="63.9" y2="112.1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" />
      </g>
      <circle cx="76" cy="100" r="4" fill="#475569" />
      <circle cx="76" cy="100" r="1.8" fill="#94a3b8" />
    </svg>
  )
}

// Road with scrolling dashes
function Road() {
  // Repeat enough dashes so the loop is seamless
  const dashW = 48
  const gap   = 32
  const unit  = dashW + gap  // 80px per dash
  const count = 14

  return (
    <div className="relative w-full overflow-hidden" style={{ height: 48 }}>
      {/* Asphalt */}
      <div className="absolute inset-0 bg-slate-800" />
      {/* Edge lines */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-slate-600" />
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-slate-600" />
      {/* Scrolling dashes */}
      <motion.div
        className="absolute top-1/2 -translate-y-1/2 flex"
        style={{ left: 0 }}
        animate={{ x: [0, -unit] }}
        transition={{ duration: 0.55, repeat: Infinity, ease: 'linear' }}
      >
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            className="shrink-0 rounded-full bg-yellow-400/50"
            style={{ width: dashW, height: 4, marginRight: gap }}
          />
        ))}
      </motion.div>
    </div>
  )
}

export function CarLoadingScreen() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-brand-950 select-none">

      {/* Stars */}
      {STARS.map((star, i) => (
        <motion.div
          key={i}
          className="pointer-events-none absolute rounded-full bg-white"
          style={{ left: star.left, top: star.top, width: star.s, height: star.s }}
          animate={{ opacity: [0.15, 0.9, 0.15] }}
          transition={{ duration: star.d, repeat: Infinity, delay: star.delay, ease: 'easeInOut' }}
        />
      ))}

      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="mb-14"
      >
        <div className="bg-white rounded-2xl px-6 py-3 shadow-xl">
          <img src="/logo.png" alt="MeuDriver" className="h-10 w-auto" />
        </div>
      </motion.div>

      {/* Scene */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        className="relative w-full max-w-sm px-4"
      >
        {/* Bouncing car */}
        <motion.div
          className="flex justify-center"
          animate={{ y: [0, -4, 0, -2.5, 0] }}
          transition={{ duration: 1.3, repeat: Infinity, ease: 'easeInOut' }}
        >
          <CarSVG />
        </motion.div>

        {/* Road sits right under the wheels */}
        <div className="-mt-1">
          <Road />
        </div>

        {/* Road gradient fade on sides */}
        <div className="pointer-events-none absolute inset-y-0 left-4 w-12 bg-gradient-to-r from-slate-900/80 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-4 w-12 bg-gradient-to-l from-slate-900/80 to-transparent" />
      </motion.div>

      {/* Loading text + dots */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.4 }}
        className="mt-10 flex items-center gap-2"
      >
        <span className="text-sm font-medium tracking-wide text-slate-400">
          Carregando
        </span>
        <div className="flex gap-1">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="block h-1.5 w-1.5 rounded-full bg-brand-500"
              animate={{ opacity: [0.2, 1, 0.2], y: [0, -3, 0] }}
              transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.2, ease: 'easeInOut' }}
            />
          ))}
        </div>
      </motion.div>
    </div>
  )
}
